import { render, staticRenderFns } from "./SeatingTypeDialog.vue?vue&type=template&id=4718c885&"
import script from "./SeatingTypeDialog.vue?vue&type=script&lang=js&"
export * from "./SeatingTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports